import { ComponentPropsWithoutRef } from "react";
import cn from "@/util/cn";

const appVersion = import.meta.env.VITE_APP_VERSION as string;

type AppInfoFooterProps = Omit<ComponentPropsWithoutRef<"footer">, "children">;

const AppInfoFooter = ({ className, ...otherProps }: AppInfoFooterProps) => (
  <footer className={cn("shrink-0 text-center text-sm text-primary/60", className)} {...otherProps}>
    <p>
      © 2025 <strong className="font-semibold">Bloomlife</strong>. All rights reserved.
    </p>
    <p>Version {appVersion}</p>
  </footer>
);

export default AppInfoFooter;
